import { getRetailerBaseUrl } from '@shared/constants/routes'
import { type ShoppingStoreDetails } from '@/features/shop/services/ShoppingStore/types'

type Props = {
  destinationUrl: string
  availableStoreIds?: number[]
  deliveryStores?: ShoppingStoreDetails[]
}

export const getNormalizedPromoUrl = ({
  destinationUrl,
  availableStoreIds,
  deliveryStores,
}: Props): {
  normalizedUrl: string
  promoStore?: ShoppingStoreDetails
} => {
  if (availableStoreIds?.length !== 1) {
    return { normalizedUrl: destinationUrl }
  }

  const promoStore = deliveryStores?.find(
    (deliveryStore) => deliveryStore.id === availableStoreIds[0],
  )

  if (!promoStore) {
    return { normalizedUrl: destinationUrl }
  }

  return {
    normalizedUrl: getRetailerBaseUrl(promoStore.name, destinationUrl) ?? '',
    promoStore,
  }
}
